export const MOBILE_VIEWPORT = '(max-width: 767px)'
export const DESKTOP_VIEWPORT = '(min-width: 768px)'
